import { Modal as MuiModal, SxProps, Theme } from '@mui/material'

interface ModalProps {
  open: boolean
  style?: any
  children: React.ReactNode
  onClose: VoidFunction
  sx?: SxProps<Theme>
  keepMounted?: boolean
}

export const Modal = (props: ModalProps) => {
  const { open, style, onClose, children, sx, keepMounted = false } = props

  return (
    <MuiModal
      open={open}
      onClose={onClose}
      // onBackdropClick={() => console.log()}
      sx={sx}
      keepMounted={keepMounted}
    >
      <div style={style}>{children}</div>
    </MuiModal>
  )
}
